var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFavoriteRed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    className: "feather feather-heart ",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 20.84,4.61 a 5.5,5.5 0 0 0 -7.78,0 L 12,5.67 10.94,4.61 a 5.5012908,5.5012908 0 0 0 -7.78,7.78 l 1.06,1.06 7.78,7.78 7.78,-7.78 1.06,-1.06 a 5.5,5.5 0 0 0 0,-7.78 z",
    fill: "#FF5500"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoriteRed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/favorite-red.b632c145.svg";
export { ForwardRef as ReactComponent };